define.alias("ember-truth-helpers/helpers/not", "settings/helpers/not");